import React, {useState, useEffect } from 'react';
import {useSelector, useDispatch} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    Typography,
    Card,
    CardContent,
    CardHeader,
    Paper,
} from '@material-ui/core';
import {ButtonTextMUI as Button} from "utils/componentsStyle";
import {red, green, orange, indigo} from "@material-ui/core/colors";
import ModalDialog from "views/Widgets/Common/ModalDialog";
import api from "utils/API";
import apiform from "utils/APIForm";
import DocumentosAdjuntosTarea from "components/ClinicalRequests/DocumentosAdjuntosTarea";
import {firstChartUpperString, toMoneyFormat} from "utils/formatFunctions"
import TableComponent from "views/Widgets/Common/TableComponent";
import {setmessageGeneral } from "actions/getGlobalAction";
import moment from "moment-timezone";
import "moment/locale/es";

moment.locale("es");

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'inline-block',
        width: "100%"
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    // avatar: {
    //   backgroundColor: red[500],
    // },
}));

const detectType = (value, key) => {
    if (key.toLowerCase().includes("fecha")) {
        return moment(value).format("YYYY-MM-DD")
    } else if (key.toLowerCase().includes("valor")) {
        return toMoneyFormat(value)
    } else if (typeof(value) === "number"){
        return value
    } else if ( typeof(value) === "boolean"){
        return value ? "Verdadero" : "Falseo"
    }
    return firstChartUpperString(value)
}

function CardObject({obj, title}){
    const classes = useStyles();

    const listKey = Object.keys(obj).map((key) => {
        let tempKeyName = key.split("_").join(" ")
        return {"key": key, "label": firstChartUpperString(tempKeyName)}
    })

    return (
    <Grid item container direction="row" justify="center" alignItems="center" xs={12} style={{margin: "10px 0"}}>
        <Card  className={classes.root} >
            <CardHeader title={`${title} - Información`} />
            <CardContent>
            <Grid item container direction="row" justify="flex-start" alignItems="flex-start" xs={12}>
                {listKey.map((key) => (
                    <Grid item container direction="row" justify="flex-start" alignItems="flex-start"  xs={6}>
                        <Grid item container direction="row" justify="flex-start" alignItems="flex-start" xs={6}>
                            <Typography component="body2" variant="body2"  style={{fontWeight: 'bold'}}>
                                {`${key["label"]}:`}
                            </Typography>
                        </Grid>
                        <Grid item container direction="row" justify="flex-start" alignItems="flex-start" xs={6}>
                            <Typography component="body2" variant="body2">
                                {detectType(obj[key["key"]] || "-", key["key"])}
                            </Typography>

                        </Grid>
                    </Grid>
                ))}
            </Grid>
            </CardContent>
        </Card>
    </Grid>
    )
}

function TableList({list, title, objectRequest}){
    const classes = useStyles();

    const headers = Object.keys(list[0]).map((key) => {
        if ( key == "id") return {label: "ID"}
        let tempKeyName = key
        if (key.includes("id_")){
            tempKeyName = key.split("id_").join(" ")
        }
        tempKeyName = tempKeyName.split("_").join(" ")

        return {label: firstChartUpperString(tempKeyName)}
    })

    let addItem = false;
    const data = list.map((row) => {
        const listData = Object.keys(row).map((key) => {
            const tempRow =  {value: row[key] || "-"}
            return tempRow
        } )
        return listData
    })


    return (
        <Grid item container direction="row" justify="center" alignItems="center" xs={12}  style={{margin: "10px 0"}}>
            <Card  className={classes.root} >
            <CardHeader title={`${title} - Detalle`} />
            
            <CardContent>
            {addItem &&
            <Grid item container direction="row" justify="flex-start" alignItems="flex-start" xs={12} style={{margin: "10px 0"}}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleAdd(title, objectRequest)}
            >
              {`Agregar Item`}
            </Button>
            </Grid>
            }
            <Grid item container direction="row" justify="flex-start" alignItems="flex-start" xs={12}>
            <TableComponent
                headers={headers}
                data={[...data]}
            />
            </Grid>
            </CardContent>
        </Card>
        </Grid>
    )
}

const CardItem = ({title, content, textAction, action}) => <Grid item container xs={4}>
    <Paper style={{ padding: "1em",  marginTop: "2em 0 0 1em", backgroundColor: "#fff", borderRadius: "5px"}}>
        <Grid item container xs={12}  direction="row" alignContent="flex-start">
            <Grid item container xs={12} style={{margin: "0 0 20px 0"}}>
                <Typography variant="h5" gutterBottom style={{ textTransform: "none", color: indigo[500] }}>
                {title}
                </Typography>
            </Grid>
            <Grid item container xs={12}>
                <Typography gutterBottom style={{ textTransform: "none", margin: "0 0 32px 0" }}>
                    {content}
                </Typography>
                {textAction &&
                <Button variant="contained" color="primary" style={{ width: "313px", height: "36px"}} onClick={action}>{textAction}</Button>
                }
            </Grid>
        </Grid>
    </Paper>
</Grid>

export default function ModalUploadAutorizationPending({
    open,
    closeModal,
    rowInfo,
    setinitialCharge,
}) {
    const dispatch = useDispatch();
    const [listItem, setlistItem] = useState([]);
    const [approvalFile, setApprovalFile] = useState(null);

    const dictTypeRequest = useSelector(state => state.currentList.DICCIONARIO_TIPO_SOLICITUD_PACIENTE);
    const dictStatusRequest = useSelector(state => state.currentList.DICCIONARIO_ESTADO_SOLICITUD_PACIENTE);

    useEffect(() => {
        api.get(`api/clinica/solicitudes/extras/${rowInfo.id}`).then((response) => {
            let tempItems = response.data.item
            tempItems = tempItems.filter((row) => (row?.objeto?.length > 0 || row?.sin_objeto === true))
            setlistItem(tempItems)
        })

      
    
    }, []);

    const handleNextStep = () => {
        const formData = new FormData();
        formData.append("archivo", approvalFile[0]);
        formData.append("tipo_documento", rowInfo.comentarios);
        formData.append("nombre_archivo", approvalFile[0].name);
        formData.append("id_paciente", parseInt(rowInfo.id_ficha.id_paciente.id));
        formData.append("id_solicitud_paciente", parseInt(rowInfo.id_solicitud_paciente.id));
        apiform.post(`/api/paciente/solicitudes/${rowInfo.id}/documentos/pendiente/subir/`, formData).then((response) => {
            setmessageGeneral(dispatch, response.data.mensaje, "success", "¡Exito!");
            setinitialCharge(true)
            closeModal()
        }).catch(() => {
            setmessageGeneral(dispatch, "No se pudo subir el documento", "error", "Error");
        })
    }



    const patientData = rowInfo.id_ficha.id_paciente

    const patientName = `${patientData.nombre} ${patientData.apellido_paterno} ${patientData.apellido_materno}`

    const typeRequest = dictTypeRequest[rowInfo?.id_solicitud_paciente?.Tipo_Solicitud_Paciente]
    const statusRequest = dictStatusRequest[rowInfo.id_solicitud_paciente.estado]

    let nameUserRequest = ""
    let coordinatorName = ""
    const userRequest = rowInfo?.id_solicitud_paciente?.id_persona_solicitante
    const coordinadorStatus = rowInfo?.id_solicitud_paciente?.id_coordinador_autoriza

    if (userRequest){
        nameUserRequest = `${userRequest["first_name"]} ${userRequest["last_name"]}`
    }
    if (coordinadorStatus){
        coordinatorName = `${coordinadorStatus["first_name"]} ${coordinadorStatus["last_name"]}`
    }

    const _requestInfoBox_ = <div className="col-xl-8 mb-3">
        <div className="card">
        <div className="card-header">
            <div className="row">
            <div className="col" />
                <div className="col-12 text-center">Datos Solicitud Paciente</div>
            </div>
        </div>
        <div className="card-body">
            <div className="row">
            <div className="col-sm text-left ml-5">
                <span className="font-weight-bold">iD tarea: </span>
                {rowInfo.id}
                <br />
                <span className="font-weight-bold">Paciente: </span>
                {patientName}
            </div>

            <div className="col-sm text-left">
                <span className="font-weight-bold">ID solicitud paciente: </span>
                {rowInfo.id_solicitud_paciente.id}
                <br />
                <span className="font-weight-bold">Tipo de solicitud: </span>
                {typeRequest?.label}
                <br />
            </div>
            <div className="col-sm text-left">
                <span className="font-weight-bold">Solicitante: </span>
                {nameUserRequest}
                <br />
                <span className="font-weight-bold">coordinador: </span>
                {coordinatorName}
                <br />
            </div>
            <div className="col-sm text-left">
                <span className="font-weight-bold">Estado: </span>
                {statusRequest?.label}
                <br />
            </div>
            </div>
            <div className="row">
            <div className="col-sm text-center" style={{padding: "20px"}}>
            </div>
            </div>
            
        </div>
        </div>
    </div>

    const _content_ = <div>
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            item
            xs={12}
            style={{margin: "10px 0"}}
        >
            {_requestInfoBox_}
        </Grid>
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            item
            xs={12}
        >
            {listItem.map((row) => (
                <div style={{width: "100%"}}>
                    {row.objeto.map((obj) => (
                        <CardObject obj={obj} title={row.titulo}/>
                    ))
                    }
                    {row.lista_insumo.length > 0 &&
                        <TableList
                            list={row.lista_insumo}
                            title={row.titulo}
                            typeRequest={typeRequest}
                            objectRequest={row.objeto[0]}
                        />
                    }
                </div>
            ))}

            <DocumentosAdjuntosTarea idTarea={rowInfo.id} />

        </Grid>
        <Grid
            item
            container
            xs={12}
            justify="center"
            style={{ marginTop: "1em" }}
            >
            <CardItem title={`Subir Autorización de isapre`}

                content={
                    <>
                    <Grid item container xs={12} justify="center">
                        {approvalFile != null ? (
                        approvalFile[0].name
                        ) : (
                        <span></span>
                        )}
                    </Grid>
                    <input
                        id="contained-button-file-isapre"
                        type="file"
                        onChange={e => setApprovalFile(e.target.files)}
                        hidden
                    />
                    <label htmlFor="contained-button-file-isapre">
                        <Button
                        variant="contained"
                        color="primary"
                        component="span"
                        style={{ textTransform: "none" }}
                        >
                        Adjuntar autorización de isapre
                        </Button>
                    </label>
                    </>
                }
            />
        </Grid>

    </div>

    const _actions_ = <>
        {approvalFile === null ?
            <Button
              mr={2}
              variant="contained"
              className="text-white"
          >
              Cargar autorización isapre
          </Button> :
            <Button
                mr={2}
                variant="contained"
                style={{backgroundColor: green[500]}}
                className="text-white"
                onClick={() =>  handleNextStep()}
            >
                Cargar autorización isapre
            </Button>
        }
        <Button
            mr={2}
            variant="contained"
            style={{backgroundColor: indigo[500]}}
            className="text-white"
            onClick={closeModal}
        >
            Cerrar
        </Button>
    </>

    return (
        <>
        <ModalDialog
            open={open}
            onClose={closeModal}
            title={`Resumen Solicitud - Subir Autorización de Isapre`}
            _content_={_content_}
            _actions_ = {_actions_}
            maxWidth="xl"
        />
        </>

    );
}